export default {"src":"/_next/static/media/SONO.52425866.svg","height":18,"width":18};